<template>
  <v-toolbar dense
             color="primary"
             height="35px">
    <span class="white--text">Routes</span>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn depressed icon color="white">
        <v-icon @click="$emit('add')">mdi-plus</v-icon>
      </v-btn>
      <v-btn depressed icon
             :disabled="!del"
             color="white">
        <v-icon @click="$emit('delete')">mdi-delete</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: "RouteListHeader",
  props: {
    del: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
